import React from 'react';
import { motion } from 'framer-motion';
import { Target, Search, ShieldCheck, Handshake } from 'lucide-react';
const steps = [{
  number: '01',
  icon: Target,
  title: 'Ordenar',
  description: 'Te ayudamos a definir qué buscar y qué evitar antes de ver propiedades. Ubicación, presupuesto y criterio claro, para no perder tiempo ni tomar malas decisiones.'
}, {
  number: '02',
  icon: Search,
  title: 'Filtrar',
  description: 'Revisamos el mercado completo y seleccionamos solo lo que realmente hace sentido. No lo que te quieren vender, sino lo que cumple con tu objetivo.'
}, {
  number: '03',
  icon: ShieldCheck,
  title: 'Evaluar',
  description: 'Analizamos si el precio está bien y te guiamos en qué revisar antes de avanzar: riesgos, documentos y estado real de la propiedad.'
}, {
  number: '04',
  icon: Handshake,
  title: 'Decidir',
  description: 'Cuando aparece una buena oportunidad, te ayudamos a avanzar con claridad: definir oferta, negociar y cerrar sin errores.'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 bg-gray-50" data-id="element-117">
      <div className="max-w-5xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-119">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900" data-id="element-120">
            Cómo funciona
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 relative" data-id="element-121">
          <div className="hidden md:block absolute top-10 left-[12%] right-[12%] h-px bg-gray-200" data-id="element-122" />

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center" data-id="element-123">
                <div className="w-20 h-20 rounded-full bg-white shadow-sm flex items-center justify-center relative z-10 mb-5" data-id="element-124">
                  <Icon size={28} className="text-brand-600" data-id="element-125" />
                  <div className="absolute -top-1.5 -right-1.5 w-7 h-7 bg-gray-900 text-white text-xs font-bold rounded-full flex items-center justify-center border-2 border-gray-50" data-id="element-126">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-127">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-128">
                  {step.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}